<template>
  <div class="quiz_count_down_bg_content">
    <div class="card_panel">
      <van-row style="margin-top: 60px;"
               type="flex"
               justify="center">
        <van-col span="12">
          <p class="quiz_title">{{ qName }}</p>
        </van-col>
      </van-row>
      <van-row style="margin-top: 60px;"
               type="flex"
               justify="center">
        <van-col span="20">
          <div class="circle-box"
               v-if="countdown !== 0">
            <van-count-down format="HH:mm:ss"
                            :time="countdown"
                            ref="countdown"
                            @finish="quizend">
              <template v-slot="timeData">
                <van-row>
                  <van-col span="7">
                    <div class="number">
                      <span v-if="timeData.days * 24 + timeData.hours < 10">0</span>
                      {{ timeData.days * 24 + timeData.hours}}
                    </div>
                  </van-col>
                  <van-col span="1">
                    <div class="maohao">
                      <div class="cir"></div>
                      <div class="cir"></div>
                    </div>
                  </van-col>
                  <van-col span="7">
                    <div class="number">
                      <span v-if="timeData.minutes < 10">0</span>
                      {{ timeData.minutes }}
                    </div>
                  </van-col>
                  <van-col span="1">
                    <div class="maohao">
                      <div class="cir"></div>
                      <div class="cir"></div>
                    </div>
                  </van-col>
                  <van-col span="7">
                    <div class="number">
                      <span v-if="timeData.seconds < 10">0</span>{{ timeData.seconds }}
                    </div>
                  </van-col>
                </van-row>
              </template>
            </van-count-down>
          </div>
          <div class="circle-box"
               v-else-if="isFinished">
            <div class="quizend">答题结束</div>
          </div>
          <div class="circle-box"
               v-else>
            <div class="quizend">无限制</div>
          </div>
        </van-col>
      </van-row>
      <van-row style="margin-top: 50px;"
               type="flex"
               justify="space-around"
               v-if="!isFinished">
        <van-col span="6"
                 class="click_able"
                 @click="setDelayShow(true)">
          <div class="button people">延时</div>
        </van-col>
        <van-col span="6"
                 class="click_able"
                 @click="shoujuan(false)">
          <div class="button quit">收卷</div>
        </van-col>
      </van-row>
      <van-row v-else
               style="margin-top: 50px;"
               type="flex"
               justify="center">
        <van-col span="8"
                 class="click_able"
                 @click="viewSituation">
          <div class="button people">查看作答情况</div>
        </van-col>
      </van-row>
    </div>
    <van-overlay :show="delayShow">
      <quizdelay @closeDelay="setDelayShow"
                 @delay="delay"></quizdelay>
    </van-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import course from "@/api/course/index";
import "@vant/touch-emulator";
import quizdelay from "@/components/home/quizdelay";
import { Row, Col, CountDown, Image, Overlay, Dialog, Toast } from "vant";
Vue.use(Row)
  .use(Col)
  .use(CountDown)
  .use(Image)
  .use(Overlay)
  .use(Dialog)
  .use(Toast);
// @ is an alias to /src
export default {
  components: {
    quizdelay,
  },
  data () {
    return {
      qName: "",
      countdown: 0,
      delayShow: false,
      isFinished: false,
      qid: "",
      codeid: "",
    };
  },
  methods: {
    async quizend (isAuto = false) {
      console.log(this.$store.state);
      let result =
        (await course.setQuizEnd({
          params: {
            codeid: this.codeid,
            quizid: this.qid,
          },
          loadingText: "正在结束测验",
          errorFn: this.handleError,
        })) || {};
      console.log("quizend", result);
      if (result.time) {
        this.countdown = 0;
        this.isFinished = true;
        await this.sendMessage("webQuiz", { cmd: "submit", option: "" });
        Dialog.alert({
          message: isAuto ? "时间到，已自动帮你提交" : "收卷成功",
        }).then((res) => {
          this.$router.replace({
            path: "/quizsituation",
            query: { qid: this.qid, cid: this.codeid },
          });
        });
      }
    },
    getCurrentTime ({ days, hours, minutes, seconds }) {
      let time = days * 24 * 60 * 60 + hours * 60 * 60 + minutes * 60 + seconds;
      return time * 1000;
    },
    shoujuan (isAuto = true) {
      const _this = this;
      Dialog.confirm({
        title: "提示",
        message: "确定要收卷吗？",
      })
        .then(() => {
          _this.quizend(isAuto);
        })
        .catch(() => { });
    },
    setDelayShow (flag) {
      if (this.countdown) {
        this.delayShow = flag;
      } else if (this.countdown === 0) {
        Toast("当前测验不限时间~");
      } else {
        Toast("测验已经结束");
      }
    },
    async sendMessage (cmd, data) {
      let params = {
        codeid: this.codeid,
        to: "wechat",
        type: cmd,
        data: JSON.stringify({ ...data }),
      };
      let { status } = await course.sendMessage({
        params: params,
        loadingText: "",
        errorFn: this.handleError,
      });
    },
    async delay (seconds) {
      console.log("delay");
      let result = await course.setQuizDelay({
        params: {
          codeid: this.codeid,
          quizid: this.qid,
          second: seconds,
        },
        loadingText: "正在延迟测验",
        errorFn: this.handleError,
      });
      console.log("quizdelay", result);
      if (result.time) {
        await this.sendMessage("webQuiz", { cmd: "delay", option: seconds });
        this.countdown = this.countdown + result.time * 1000;
      }
    },
    async getQuestionDetail () {
      try {
        let { courseId } = this.$store.state.course;
        const { quizzes } = await course.getQuizList({
          params: { courseids: [courseId] },
          loadingText: "正在获取课程测验信息",
          errorFn: this.handleError,
        });
        console.log("quiz detail===", quizzes);
        let { time } = await course.getTimestamp({
          errorFn: this.handleError,
        }); // 获取服务器时间戳
        let quizData = quizzes.filter((v) => v.id === this.qid)[0];
        if (!quizData) throw new Error("找不到该测验!");
        let { timeclose, timelimit, timeopen, name } = quizData;
        this.qName = name;
        if (timeopen) {
          if (timeopen - time > 0) {
            Dialog({
              title: "提示",
              message: "测验还没开放",
            }).then(() => {
              this.$router.replace("/home");
            });
          }
        }
        if (timeclose) {
          if (timeclose - time > 0 && time - timeopen > 0) {
            this.countdown = (timeclose - time) * 1000;
            if (timeclose - time > 3) this.countdown = this.countdown - 2;
          } else {
            this.isFinished = true;
          }
        }
        console.log("timeclose", timeclose);
        console.log("time", time);
        console.log("countdown", this.countdown);
        // this.countdown = 10 * 60 * 1000; // 十分钟(转换成毫秒)
        // this.countdown = 80 * 60 * 60 * 1000;
        // this.countdown = 30 * 10;
      } catch (error) {
        console.log(error);
        Dialog.alert({
          title: `提示`,
          message: error.msg || error,
        }).then(() => { });
      }
    },
    async viewSituation () {
      try {
        await this.sendMessage("webQuiz", { cmd: "viewDetail", option: "" });
        this.$router.replace({
          path: "/quizsituation",
          query: { qid: this.qid, cid: this.codeid },
        });
      } catch (error) {
        console.log(error);
        Dialog.alert({
          title: `提示`,
          message: error.msg || error,
        }).then(() => { });
      }
    },
    async onmessage () {
      const _this = this;
      this.$root.$on("delayQuiz", ({ time }) => {
        // this.countdown = 0;
        this.getQuestionDetail();
        // console.log("测验延时", time, "秒");
        // time = (time - 2) * 1000;
        // console.log(this.$refs.countdown.timeData);
        // this.countdown =
        //   this.getCurrentTime(this.$refs.countdown.timeData) + time;
        // console.log("countdown", this.countdown, "秒");
      });
    },
  },
  created () {
    this.onmessage();
  },
  mounted () {
    let { qid, cid } = this.$route.query;
    this.qid = qid ? parseInt(qid) : this.$store.state.course.code;
    this.codeid = cid || this.$store.state.course.qcodeid;
    this.getQuestionDetail();
  },
};
</script>
<style lang="less" scoped>
.quiz_count_down_bg_content {
  height: 100%;
  position: relative;
  padding: 50px 160px;
  z-index: 9;
  .card_panel {
    height: 100%;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2);
    border-radius: 48px;
    padding: 60px;
    overflow-y: auto;
  }
  .w100 {
    width: 100%;
  }
  .happy-scroll-content {
    width: 100%;
  }
  .quiz_title {
    word-break: break-all;
    font-size: 54px;
    font-weight: bold;
    color: #333;
    text-align: center;
  }
  .circle-box {
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 253, 246, 1) 100%
    );
    box-shadow: 0px 10px 30px 0px rgba(255, 217, 122, 0.1);
    border-radius: 47px;
    border: 2px solid rgba(255, 236, 190, 1);
    height: 340px;
    padding: 40px;
    .quizend {
      height: 100%;
      color: #ff9f00;
      font-size: 110px;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .van-count-down {
      height: 100%;
      .van-row {
        height: 100%;
        .van-col {
          height: 100%;
          .number {
            font-size: 130px;
            color: #ff9f00;
            font-weight: bold;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            background-image: url("/images/time_box@2x.png");
            background-repeat: no-repeat;
            background-size: contain;
            background-position: center;
          }
          .maohao {
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            flex-direction: column;
            .cir {
              width: 20px;
              height: 20px;
              border-radius: 50%;
              background: #ff9f00;
            }
          }
        }
      }
    }
  }
  .button {
    padding: 20px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
    font-weight: bold;
    border-radius: 40px;
    color: #ffffff;
  }
  .people {
    background: #37ab7e;
    border: 2px solid rgba(55, 171, 126, 1);
  }
  .quit {
    background: #ffffff;
    color: #37ab7e;
    border: 2px solid rgba(55, 171, 126, 1);
  }
}
</style> 